<button class="grid-filters-tag-remove-button" [id]="gridFilterTag?.id" (click)="remove.emit(gridFilterTag)">
    @if (gridFilterTag?.priceRange) {

    {{ gridFilterTag?.priceRange.valueMinCurrent | hCurrency : "short" }} -
    {{ gridFilterTag?.priceRange.valueMaxCurrent | hCurrency : "short" }}

    } @else {
    {{ gridFilterTag?.filter.name }}
    }
    <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.comma-separator">,&nbsp; </span>
    <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.remove_filter"> remove this filter </span>
    <h-svg-icon [name]="'cross-rounded'" class="icon-delete"></h-svg-icon>
</button>
<ng-template #priceRange>
    {{ gridFilterTag?.priceRange.valueMinCurrent | hCurrency : "short" }} -
    {{ gridFilterTag?.priceRange.valueMaxCurrent | hCurrency : "short" }}
</ng-template>
<ng-template #filter>{{ gridFilterTag?.filter.name }}</ng-template>
